import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCartOpen } from 'Scripts/Slices/cart';
import { IRootState } from 'Scripts/store';

import { useLazyHasCartQuery } from 'Services/cartApi';

import { IHeaderViewModelTranslations, ILinkModel } from 'Types/Litium';
import CustomerServiceCart from 'Components/CustomerServiceCart';
import BagIcon from 'Icons/bag.svg?react';

type MiniCartButtonProps = {
    miniCartOpenText: IHeaderViewModelTranslations['minicartOpen'];
};

const MiniCartButton = ({
    miniCartOpenText,
}: MiniCartButtonProps) => {
    const [showMiniCart, setShowMiniCart] = useState(false);
    const [getCart] = useLazyHasCartQuery();

    const miniCartContainerRef = useRef();
    const dispatch = useDispatch();
    const {
        miniCartModel: { shoppingCart },
        setCartOpen,
        hasAnythingInCart,
    } = useSelector((state: IRootState) => state?.cart);

    const handleTrapFocusForMiniCartButton = (
        event: React.KeyboardEvent<HTMLButtonElement>
    ) => {
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                setShowMiniCart(false);
            }
        }
    };

    const cartCriteria = shoppingCart?.totalQuantity > 0 || hasAnythingInCart;

    useEffect(() => {
        getCart();
    }, [shoppingCart]);

    useEffect(() => {
        if (!showMiniCart) {
            if (setCartOpen) {
                setShowMiniCart(true);
                dispatch(toggleCartOpen(false));
            }
        }
    }, [setCartOpen, shoppingCart]);

    return (
        <>
            <div className="relative lg:py-4.5">
                <button
                    ref={miniCartContainerRef}
                    onClick={() => {setShowMiniCart(!showMiniCart)}}
                    onKeyDown={event => handleTrapFocusForMiniCartButton(event)}
                    className="relative flex"
                >
                    <span className="sr-only">{miniCartOpenText}</span>
                    <BagIcon className="h-6 w-6" />
                </button>
                {cartCriteria &&  
                    <span className="pointer-events-none absolute right-[-3px] top-0.5 h-2.5 w-2.5 rounded-full bg-cadillac lg:top-5"/>
                }
            </div>
            {showMiniCart && (
                <div
                    className="fixed right-0 top-0 z-20 max-h-[100dvh] bg-white shadow-lg"
                >
                    <CustomerServiceCart
                        isOpen={showMiniCart}
                        setIsOpen={setShowMiniCart}
                    />
                </div>
            )}
        </>
    );
};

export default MiniCartButton;
